import { FlexLayout, Text } from '@deity/falcon-ui';
import { ArrowForward } from '@mui/icons-material';
import type { FC } from 'react';
import { Link } from 'react-router-dom';

type VersionPropertyProps = {
  title: string;
  link: string;
  icon: JSX.Element;
  iconColor?: string;
};
const VersionProperty: FC<VersionPropertyProps> = ({ title, link, icon, iconColor = 'primaryText', children }) => (
  <Link to={link} style={{ textDecoration: 'none' }}>
    <FlexLayout alignItems="center">
      <Text color="secondary" fontWeight="bold" css={{ textTransform: 'uppercase' }}>
        {title}
      </Text>
      <FlexLayout alignItems="center" mx="xss" color={iconColor as any}>
        {icon}
      </FlexLayout>
      {children}
      <FlexLayout alignItems="center" color="secondary" ml="xs">
        <ArrowForward style={{ height: '20px' }} />
      </FlexLayout>
    </FlexLayout>
  </Link>
);

export default VersionProperty;
